<template>
    <el-dialog
    title="详情"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    width="80rem">
        <div class="top-box">
           <div class="first-line">
            <div class="item">
                <p class="title-style">考核名称：</p>
                <p class="overflow">{{ detail.examineName }}</p>
            </div>
            <div class="item">
                <p class="title-style">答题时间：</p>
                <p class="overflow">{{ detail.answerTime+'分钟' }}</p>
            </div>
            <div class="item">
                <p class="title-style">满分：</p>
                <p class="overflow">{{detail.fullScore}}</p>
            </div>
           </div>
           <div class="first-line">
            <div class="item">
                <p class="title-style">合格分：</p>
                <p class="overflow">{{ detail.passScore?detail.passScore+'分':''}}</p>
            </div>
            <div class="item">
                <p class="title-style">开始时间：</p>
                <p class="overflow">{{ detail.beginTime }}</p>
            </div>
            <div class="item">
                <p class="title-style">结束时间：</p>
                <p class="overflow">{{detail.endTime}}</p>
            </div>
           </div>
           <div class="relate-item">
                <p class="title-style">关联班级：</p>
                <div v-if="detail.classInfoList" class="class-item-box">
                    <div v-for="(item,index) in detail.classInfoList"  class="class-item" :key="index">
                        <div>{{ item.className }}</div>
                        <div v-if="index<detail.classInfoList.length-1">，</div>
                    </div>
                </div>
           </div>
        </div>
        <div class="content">
            <no-data v-if="!detail.softwareScoreConfigList||detail.softwareScoreConfigList.length==0"></no-data>
            <div class="content-item" v-for="(item,index) in detail.softwareScoreConfigList&&detail.softwareScoreConfigList" :key="index">
                <div class="item">
                    <p class="title-style">考核软件：</p>
                    <el-tooltip class="item" effect="dark" :content="item.softwareName" placement="top-start">
                        <p class="overflow">{{ item.softwareName }}</p>
                    </el-tooltip>
                </div>
                <div class="item">
                    <p class="title-style">分数占比：</p>
                    <p class="overflow">{{ item.scoreRatio }}</p>
                </div>
                <div class="item">
                    <p class="title-style">总分：</p>
                    <p class="overflow">{{ item.fullScore }}</p>
                </div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import { GetSoftwareConfigScore } from '@/api/examine';
import NoData from '../../../common/NoData.vue';
    export default {
  components: { NoData },
        data(){
            return {
                dialogVisible:false,
                /**详情 */
                detail:{},
            }
        },
        methods:{
            /**考核分数配置详情 */
            getSoftwareConfigScore(id){
                GetSoftwareConfigScore({id}).then(res=>{
                    if(res.code==200){
                        this.detail=res.data;
                        this.dialogVisible=true;
                    }
                })
            }
        }
    }
</script>

<style lang="less" scoped>
/deep/.el-dialog__title{
    font-size: 16px;
    font-weight: 700;
}
/deep/.el-dialog{
    border-radius: 16px;
}
/deep/.el-dialog__body{
    padding:0 5rem 5rem 5rem;
}
/deep/.el-dialog__header{
    padding: 3rem 5rem;
}
.first-line{
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.item{
        display: flex;
        align-items: center;
        &> :nth-child(2){
            width: 15rem;
        }
    }
.top-box{
    color: #334681;
    padding-bottom: 2.8rem;
    border-bottom: 1px solid #E0E8F2;
    &> :nth-child(n){
        margin-top: 2rem;
    }
    &> :nth-child(1){
        margin-top: 0;
    }
}
.title-style{
    color: #8590B3;
    width: 7rem;
    text-align: right;
}
.relate-item{
    display: flex;
    &> :nth-child(2){
        width: calc(100% - 8rem);
        p{
            width: 100%;
        }
    }
}
.content-item{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 2.2rem;
    color: #334681;
}
.content{
    height: 40rem;
    overflow: auto;
}
.class-item-box{
    display: flex;
    flex-wrap: wrap;
}
.class-item{
    display: flex;
    white-space: var(--lineWrap);
}
</style>